import { css } from "@emotion/react";

export const root = css`
  width: 100vw;
  margin-left: calc(50% - 50vw);
  background: #f5f5f3;
`;

export const inner = css`
  width: 100%;
  padding: 0 24px 0;

  @media (max-width: 1024px) {
    padding: 0 20px;
  }

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

export const topGrid = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const bottomGrid = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const card = css`
  position: relative;
  display: block;
  text-decoration: none;
  overflow: hidden;
`;

export const image = css`
  width: 100%;
  height: 600px;
  object-fit: cover;
  display: block;

  @media (max-width: 1024px) {
    height: 420px;
  }

  @media (max-width: 768px) {
    height: 320px;
  }
`;

export const label = css`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 28px;
  line-height: 1.1;
  font-weight: 400;
  letter-spacing: 0.4px;
  color: #ffffff;
  text-align: center;
  pointer-events: none;

  @media (max-width: 1024px) {
    font-size: 24px;
  }

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

export const middleBanner = css`
  min-height: 84px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 20px;
  line-height: 1.2;
  font-weight: 400;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #1f1f1f;
  text-align: center;

  @media (max-width: 768px) {
    min-height: 64px;
    font-size: 16px;
    padding: 0 12px;
  }
`;
